// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"26c6ecd7","303":"2a4ba031","902":"0b4dddff","954":"1a34d142"}[chunkId] + ".chunk.js";
};